import { ImageView, ViewOpts } from '@play-co/timestep-core/ui';
import { BaseBitmapFont } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

type BadgeStyle = 'red' | 'green';
export type NotificationBadgeOpts = Omit<ViewOpts, 'width' | 'height'> & {
  size: number;
  textColor: string;
  fontSize: number;
  font: string | BaseBitmapFont;
  style: BadgeStyle;
};

const textPadding = 5;

export default class NotificationBadge extends ImageView {
  private text: LangBitmapFontTextView;

  constructor(opts: NotificationBadgeOpts) {
    const { size, style, fontSize } = opts;

    super({
      ...opts,
      width: size,
      height: size,
      image: `assets/ui/shared/icons/notification_${style}.png`,
    });

    this.text = new LangBitmapFontTextView({
      superview: this,
      width: size - textPadding * 2,
      height: size - textPadding * 2,
      x: textPadding - 2,
      y: textPadding,
      align: 'center',
      verticalAlign: 'center',
      size: fontSize,
      font: 'Body',
      color: 'white',
    });
  }

  public updateStyle(style: BadgeStyle) {
    this.updateOpts({
      image: `assets/ui/shared/icons/notification_${style}.png`,
    });
  }

  public setText(text: string) {
    this.text.localeText = () => text;
  }
}
